<template>

  <div>
    <div class="sub-header">
      <div class="width-wrapper relative">
        <div class="page-title page-title-ph">{{pharmacy.title}} [<span class="pharmacy-list-item__cats-item" v-for="category in pharmacy.categories">{{category.title}}</span>]</div>

        <div class="pharmacy-header__cats"></div>
        <div class="pharmacy-header__supervisor"></div>

        <div class="header__save" >
          <a href="#" title="" v-if="$route.path.includes(`/pharmacies/${$route.params.id}/racks/`)" class="button" @click.prevent="print">Печать</a>

          <span  v-if="$store.state.user.role == 'HM'">
          <router-link  title="" :to="{ path: `/pharmacies/${$route.params.id}/racks/new/` }" class="button button--inverse">Добавить стеллаж</router-link>
          <a href="#"  title="" class="button" @click.prevent="save">Сохранить изменения</a>
          </span>

          <span  v-if="$store.state.user.role == 'PM'" class="version-info">

            Версия {{pharmacy.version.title}} [{{statuses[pharmacy.version.status]}}]
          <a href="#"  title="" class="button" @click.prevent="changeVersionStatus('SEEN')" v-show="pharmacy.version.status === 'NEW'">Взять работу</a>
          <a href="#"  title="" class="button" @click.prevent="changeVersionStatus('DONE')" v-show="pharmacy.version.status === 'SEEN'">Расставлено</a>

          </span>
        </div>

        <div class="header-tabs">
          <router-link activeClass="header-tabs__link-active" class="header-tabs__link" exact :to="`/pharmacies/${$route.params.id}/`">Планировка</router-link>
          <router-link activeClass="header-tabs__link-active" class="header-tabs__link" :to="`/pharmacies/${$route.params.id}/racks/`">Стеллажи</router-link>
        </div>

      </div>
    </div>



    <router-view></router-view>


  </div>

</template>


<script type="text/javascript">
  import axios from 'axios';

  export default {
    name: 'pharmacy',
    created() {
      this.loadPharmacyInfo();
    },
    data() {
      return {
        pharmacy: { categories: [] },
        statuses: {
          NEW: 'Новая',
          SEEN: 'В работе',
          DONE: 'Сделано',
        },
      };
    },
    methods: {
      loadPharmacyInfo() {
        const that = this;
        axios.get(`/api/v2/pharmacies/${this.$route.params.id}/`).then((response) => {
          that.isLoading = false;
          this.pharmacy = response.data;
        });
      },
      changeVersionStatus(status) {
        const that = this;
        axios.patch(`/api/v2/versions/${that.pharmacy.version.id}/`, { status }).then((response) => {
          that.isLoading = false;
          that.pharmacy.version.status = status;
          console.log(response);
        });
      },
      print() {
        window.print();
      },
      save() {
        this.$emit('save');
      },
    },
  };
</script>


<style type="text/css" lang="less" >

  .version-info {
    color: #ffffff;
  }

  .page-title-ph{
    font-size: 18px !important;
    color: #FFFFFF;
    padding-right: 370px;
  }

  .sub-header .width-wrapper{
    height: 110px !important;
  }

  .holder{
    top:200px !important;
  }

  .pharmacy-edit-type{

    font-size: 0;
    padding: 20px 16px;
    position: absolute;
    z-index: 10;

    &__link{
      display: inline-block;
      width: 150px;
      text-align: center;
      height: 32px;
      line-height: 32px;
      font-size: 14px;
      font-weight: bold;
      text-decoration: none;
      color:#3F6FA7;
      background: #FFFFFF;
      cursor: pointer;

      &:first-child{
        border-radius: 4px 0 0 4px;
      }
      &:last-child{
        border-radius: 0 4px 4px 0;
      }

      &--current{
        color:#FFFFFF;
        background: #3F6FA7;
      }
    }
  }


  @media print {
    .holder{
      position: static;
      margin-top: 30px;
    }

    .navigation{
      position: static;
      width: auto;
      border-left: 20px solid transparent;

      .filter{
        display: none;
      }

      .table-holder{
        position: static !important;
      }

      .anti-facing td {
        background: none!important;
      }


    }

    .editor-field{
      position: static;
      /*display: none;*/
      page-break-before: always;

      .container{
        position: static !important;
        transform: scale(0.8);
        transform-origin: 0;
      }

      .change-view{
        display: none;
      }

      .back{
        display: none !important;
      }

      .shelf{
        transform: none !important;
      }
    }
  }

</style>


// WEBPACK FOOTER //
// Pharmacy.vue?4a5077a0